import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { map } from 'jquery';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Subject, of } from 'rxjs';
import { catchError, takeUntil, tap } from 'rxjs/operators';
import { UserService } from '../../../_services/index';
import { ConfirmPasswordValidator } from '../../confirm-password.validator';
import { icons } from '../../../sharedcomp/constans/icons.constans';
import { Router } from '@angular/router';
import { PasswordValidator } from '../../../_helpers/form-validators/password-validator';

@Component({
  selector: 'app-new-password',
  templateUrl: './new-password.component.html',
  styleUrls: ['./new-password.component.css', '../../../../assets/css/new-component-view.css', '../../../../assets/css/new-form-elements.css', '../../../../assets/css/new-buttons-theme.css']
})
export class NewPasswordComponent implements OnInit, OnDestroy {

  passwordForm: FormGroup;
  userKcoreId: string;
  icons: typeof icons;
  updateSucess: boolean = false;
  updateError: boolean = false;

  private destroy$ = new Subject<void>();

  constructor(
    private userService: UserService,
    private spinnerService: Ng4LoadingSpinnerService,
    private fb: FormBuilder,
    private router: Router
  ) {
    this.icons = icons;
    this.initPasswordForm();
   }

  ngOnInit() {
    this.userKcoreId = localStorage.getItem('userId');
    if (this.userKcoreId == null || this.userKcoreId == undefined) {
      this.goBack();
    }
  }

  initPasswordForm() {
    this.passwordForm = this.fb.group({
      newPassword: ['', [
        Validators.required,
        Validators.minLength(8),
        PasswordValidator.patternValidator(/\d/, { hasNumber: true }),
        PasswordValidator.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
        PasswordValidator.patternValidator(/[a-z]/, { hasSmallCase: true }),
        PasswordValidator.patternValidator(/[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/, { hasSpecialCharacters: true })
      ]],
      confirmPassword: ['', Validators.required]
    }, { validator: PasswordValidator.passwordMatchValidator });
  }

  goBack() {
    this.router.navigateByUrl('/dashboard');
  }

  updatePassword(configurationProfileForm: FormGroup) {
    this.spinnerService.show();
    this.updateSucess = false;
    this.updateError = false;

    const passwordFormValue = configurationProfileForm.value;

    this.userService.changepassword(this.userKcoreId, passwordFormValue)
      .pipe(
        takeUntil(this.destroy$),
        tap(val => {
          this.updateSucess = true;
          this.spinnerService.hide();
        }),
        catchError(error => {
          this.updateError = true;
          this.spinnerService.hide();
          console.error('Failed while trying to update the user password details.' + error);
          return of(error);
        })
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
